var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"tally-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('add-tally', _vm.value)}}},[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }